import {hostName} from "../../../endpoint";
import {defaultHeaders} from "../../../headers";

export const create = async (role) => {
  try {
    const result = await fetch(`${hostName}/business/team-role`, {
      method: "POST",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(role),
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
